import { immer } from 'zustand/middleware/immer';
import { create } from 'zustand';
import _ from 'lodash';

import { initialState, Personal, PersonalStore } from './store.entity';

export const usePersonalStore = create<
  PersonalStore,
  [['zustand/immer', never]]
>(
  immer((set, get) => ({
    ...initialState,
    computed: {
      get selectedPerson() {
        return get().personal.find(
          (person) => person?.id?.toString?.() === get().personId
        ) as Personal;
      },
    },
    setLayoutContent(content) {
      set((state) => {
        state.layout = {
          ...state.layout,
          ...content,
        };
      });
    },
    setCampaignId(campaignId) {
      set((state) => {
        state.campaign = campaignId;
      });
    },
    setPersonalInfo(personal) {
      set((state) => {
        state.personal = personal;
      });
    },
    setPersonId(id) {
      set((state) => {
        state.personId = id;
      });
    },
    setNewPerson(person) {
      set((state) => {
        state.personal = [...state.personal, person];
      });
    },
    editPerson(data) {
      set((state) => {
        state.personal = state.personal.map((person) =>
          person.document.toString() === data.document.toString()
            ? { ...data, id: person.id }
            : person
        );
      });
    },
    deletePerson(id: string) {
      set((state) => {
        state.personal = [...state.personal].filter(
          (person) => person.id !== id
        );
      });
    },
    reset() {
      set(() => initialState);
    },
  }))
);
